/**
 * @ngdoc controller
 * @name LoginController
 * @description
 * This component renders the Login section.
 *
 * @memberof account
 */
class LoginController {
  /**
   * Class constructor.
   * @param {Service} $location             To redirect the user when the login process finishes.
   * @param {Object}  $rootScope            To broadcast the authorization and tracking events.
   * @param {Service} contentCreatorAppAPI  To send the login request.
   * @param {Object}  AUTH_EVENTS           To get the name of the events to be broadcasted.
   * @param {Object}  TRACKING_EVENTS       To get the name of the events to be broadcasted.
   * @ignore
   */
  constructor(
    $location,
    $rootScope,
    contentCreatorAppAPI,
    AUTH_EVENTS,
    TRACKING_EVENTS,
  ) {
    'ngInject';

    /**
     * The local reference to the `$location` service.
     * @type {Object}
     */
    this.$location = $location;
    /**
     * The local reference to the `$rootScope` object.
     * @type {Object}
     */
    this.$rootScope = $rootScope;
    /**
     * The local reference to the `contentCreatorAppAPI` service.
     * @type {Object}
     */
    this.contentCreatorAppAPI = contentCreatorAppAPI;
    /**
     * The local reference to the `AUTH_EVENTS` constant.
     * @type {Object}
     */
    this.AUTH_EVENTS = AUTH_EVENTS;
    /**
     * The local reference to the `TRACKING_EVENTS` constant.
     * @type {Object}
     */
    this.TRACKING_EVENTS = TRACKING_EVENTS;
    /**
     * The local reference to the `user` input.
     * @type {String}
     */
    this.user = '';
    /**
     * The local reference to the `password` input.
     * @type {String}
     */
    this.password = '';
    /**
     * To show an error or not.
     * @type {Boolean}
     */
    this.error = false;
    /**
     * To show an error or not for invalid user and password.
     * @type {Boolean}
     */
    this.invalidUserPassword = false;
    /**
     * To display the password or not.
     * @type {Boolean}
     */
    this.showPassword = false;
  }
  /**
   * Handle the login action.
   */
  login() {
    this.invalidUserPassword = false;

    if (!this.user || !this.password) {
      this.error = true;
      return;
    }

    this.$rootScope.$broadcast(this.TRACKING_EVENTS.navigation.clickLogin);

    this.contentCreatorAppAPI.login(this.user, this.password)
    .then((session) => {
      this.$rootScope.$broadcast(this.AUTH_EVENTS.loginSuccess, session);
      this.$location.url('/');
    })
    .catch(() => {
      this.$rootScope.$broadcast(this.AUTH_EVENTS.loginFailed);
      this.invalidUserPassword = true;
    });
  }
  /**
   * Handle the change of visibility of the password.
   */
  togglePassword() {
    this.showPassword = !this.showPassword;
  }
  /**
   * Handle if the form should display any error or not.
   */
  shouldDisplayError() {
    return this.invalidUserPassword
            || (
              this.error
                && (!this.user || !this.password)
            );
  }
}

export default LoginController;



// WEBPACK FOOTER //
// ./src/frontend/modules/account/components/login/login.controller.js